var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgInformation = function SvgInformation(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9928 5.37555 18.6244 0.00716485 12 0ZM12.25 5C13.0784 5 13.75 5.67157 13.75 6.5C13.75 7.32843 13.0784 8 12.25 8C11.4216 8 10.75 7.32843 10.75 6.5C10.75 5.67157 11.4216 5 12.25 5ZM10.5 18.5H14.5C15.0523 18.5 15.5 18.0523 15.5 17.5C15.5 16.9477 15.0523 16.5 14.5 16.5H13.75C13.6119 16.5 13.5 16.3881 13.5 16.25V11.5C13.5 10.3954 12.6046 9.5 11.5 9.5H10.5C9.94771 9.5 9.5 9.94771 9.5 10.5C9.5 11.0523 9.94771 11.5 10.5 11.5H11.25C11.3881 11.5 11.5 11.6119 11.5 11.75V16.25C11.5 16.3881 11.3881 16.5 11.25 16.5H10.5C9.94771 16.5 9.5 16.9477 9.5 17.5C9.5 18.0523 9.94771 18.5 10.5 18.5Z",
    fill: "#FFAE64"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgInformation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Information.efef211406e3b43ae872581d8f2045fd.svg";